// extracted by mini-css-extract-plugin
export default {"likeButton":"m8-z","unLikedButton":"n8-z","likedButton":"o8-z"};